import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const appConfigInitialState: AppConfigState = {
  betLoopAccessErrorStatus: null,
}

const appConfigSlice = createSlice({
  name: 'app-config',
  initialState: appConfigInitialState,
  reducers: {
    setBetLoopAccessErrorStatus(
      state,
      { payload }: PayloadAction<AppConfigState['betLoopAccessErrorStatus']>
    ) {
      if (state.betLoopAccessErrorStatus === payload) return
      state.betLoopAccessErrorStatus = payload
    },
  },
})

export const { setBetLoopAccessErrorStatus } = appConfigSlice.actions

export default appConfigSlice.reducer

// =====
// Types
// =====

interface AppConfigState {
  betLoopAccessErrorStatus: 'banned' | 'unavailable' | null
}
